import { render, staticRenderFns } from "./hyundaiBody.vue?vue&type=template&id=fc990cd2&scoped=true&"
import script from "./hyundaiBody.vue?vue&type=script&lang=js&"
export * from "./hyundaiBody.vue?vue&type=script&lang=js&"
import style0 from "./hyundaiBody.vue?vue&type=style&index=0&id=fc990cd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc990cd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VCard,VContent})
